import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { MainComponent} from './angular-bot/main/main.component';
import { GoldFinchChatPage } from './gold-finch-chat.page';
import { BaseAppRouteGuardService } from '../core/services/base-app-route-guard.service';
const routes: Routes = [
    {
        path: '',
        component: GoldFinchChatPage,
        canActivate: [BaseAppRouteGuardService],
        data: {
            Permission: 'ACCESS_GOLDFINCH',
            title: "Gold Finch Chat"
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class GoldFinchChatRoutingModule { };